// THEME ADMIN.

const theme1 = {
  components: {
    Menu: {
      itemBg: "rgba(255,255,255,0)",
      itemSelectedBg: "transparent",
      itemSelectedColor: "rgb(0,0,0)",
      subMenuItemBg: "rgba(0,0,0,0)",
      colorText: "rgba(0,0,0,0.65)",
      colorSplit: "rgba(5,5,5,0)",
      itemColor: "rgba(0,0,0,0.47)",
    },
  },
};

// functions

export const getThemes = () => {
  return {
    theme1,
  };
};
